import { isEmpty, isNil } from 'lodash/fp';
import { createErrorNode } from 'app/store/migration/utils.js';
import { clientWrapper } from './clientWrapper.js';

export const runAction = (dispatch, type, name, actionType, params) => {
    const client = clientWrapper(dispatch, params);

    client
        .then(() => {
            dispatch({
                type: `${type}/progress`,
                payload: { name, type: actionType }
            });
        })
        .catch((error) => {
            dispatch({
                type: `${type}/failed`,
                payload: { name, type: actionType, error }
            });
        });

    return client;
};

export function graphBuilderMiddleware({ dispatch, getState }) {
    return (next) => (action) => {
        const { type, projectUid, nodeActions, dependencies, onSucceeded } = action;

        if (!projectUid || !nodeActions) {
            return next(action);
        }

        const completedActions = {};

        const getBatch = () => {
            const batch = [];

            nodeActions.forEach((nodeAction) => {
                if (nodeAction && !completedActions[nodeAction.id]) {
                    if (
                        !dependencies[nodeAction.id] ||
                        dependencies[nodeAction.id].every(
                            (sourceId) => !isNil(completedActions[sourceId])
                        )
                    ) {
                        batch.push(nodeAction);
                    }
                }
            });

            return batch;
        };

        const runBatch = (batch) => {
            if (isEmpty(batch)) {
                dispatch({ type: `${type}/succeeded` });

                if (onSucceeded) {
                    onSucceeded({ dispatch, getState, completedActions });
                }

                return;
            }

            const actions = batch.map((item) => {
                const sources = dependencies[item.id]?.map(
                    (sourceId) => completedActions[sourceId]
                );

                return runAction(
                    dispatch,
                    type,
                    item.suggestedName,
                    item.type,
                    item.params(projectUid, sources)
                ).catch((e) => {
                    console.warn('Error creating node from sheet', item, e);
                    if (item.type === 'Model') {
                        return;
                    }
                    return runAction(
                        dispatch,
                        type,
                        item.suggestedName,
                        'Error',
                        createErrorNode(item.suggestedName, projectUid, sources, e)
                    );
                });
            });

            Promise.all(actions).then((values) => {
                values.forEach((value, i) => {
                    completedActions[batch[i].id] = { ...batch[i], ...value.viewRef };
                });

                runBatch(getBatch(nodeActions));
            });
        };

        runBatch(getBatch(nodeActions));
    };
}
